module.exports = __webpack_public_path__ + "static/media/09.66958eb9.jpg";